export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Artistic%20minimalist%20fashion%20editorial%20flatlay%20on%20soft%20warm%20cream%20surface%2C%20carefully%20curated%20selection%20of%20modern%20streetwear%20items%20including%20textured%20knit%20sweater%20and%20sleek%20leather%20accessories%20arranged%20with%20intentional%20negative%20space%2C%20soft%20diffused%20natural%20window%20lighting%20from%20left%20side%2C%20editorial%20lifestyle%20photography%2C%20warm%20amber%20and%20sand%20tones%2C%20sophisticated%20contemporary%20composition%2C%20high%20end%20catalog%20aesthetic&width=1600&height=900&seq=hero-main-kakobuy-02&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-background-50/20 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6 border border-background-50/30">
            <i className="ri-sparkling-line text-accent-400 text-sm"></i>
            <span className="text-xs font-medium text-background-50">2026 • Zaktualizowany</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-background-50 leading-tight mb-5">
            Kakobuy Spreadsheet Polska – Znajdź najlepsze produkty szybciej
          </h1>

          <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-8 max-w-lg">
            Kakobuy Spreadsheet to najprostszy sposób na odkrywanie popularnych produktów, sneakersów, ubrań streetwear oraz najlepszych okazji zakupowych.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-7 py-3.5 rounded-full text-sm font-semibold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Przeglądaj Kakobuy Spreadsheet
            </a>
            <a
              href="#how-it-works"
              className="bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 px-7 py-3.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer border border-background-50/20"
            >
              Jak działa Kakobuy?
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-5">
            {['Aktualne listy produktów', 'Kategorie produktów', 'Poradniki dla początkujących', 'Bezpieczne zakupy'].map((item, idx) => (
              <div key={idx} className="flex items-center gap-2 text-background-50/80 text-xs font-medium">
                <i className="ri-check-line text-accent-400 text-sm"></i>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}